import React from 'react';
export function DescriptionSection() {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 md:p-10 mb-12" data-id="element-1850">
      <div className="max-w-4xl mx-auto space-y-6 text-gray-700 text-lg leading-relaxed" data-id="element-1851">
        <p data-id="element-1852">
          Fast Wire EDM machines are specifically designed for cutting parts
          with poor to extremely challenging flushing conditions. These machines
          have been particularly well received within the 3D metal printing
          industry, where they are commonly used to separate parts from
          populated build plates.
        </p>
        <p data-id="element-1853">
          Fast Wire EDM systems can cut a populated build plate 3–5× faster than
          conventional wire EDM. This advantage comes from not relying on
          high-pressure water flushing or fully submerged work tanks. Instead, a
          rapidly moving wire—traveling at approximately 5 meters per
          second—effectively clears chips from the cutting zone, enabling higher
          cutting efficiency.
        </p>
        <p data-id="element-1854">
          The wire is typically about 300 meters in length, made from
          high-tensile molybdenum (moly) with an approximate diameter of 0.007
          inches. It is continuously reused as it reciprocates back and forth
          through the workpiece, keeping operating costs low—consumable wire and
          filtration average approximately $2.00 per hour.
        </p>
        <p data-id="element-1855">
          Most Fast Wire EDM machines feature full 4-axis capability, allowing
          them to cut complex shapes, tapers, and many of the same geometries
          achievable with conventional wire EDM. Many models also include
          integrated CAD functionality as a standard feature.
        </p>
        <p data-id="element-1856">
          Available in both vertical and horizontal wire configurations, with
          larger models continually being introduced to accommodate the
          increasing build plate sizes of newly developed 3D printers.
        </p>
      </div>
    </div>;
}